(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card"] && !Shopify.designMode) return;
  try {
    function formatMoneyFromCents(cents) {
    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'EUR',
    }).format(cents / 100);
  }

  function getPriceWithVatCents(priceCents) {
    return priceCents;
  }

  function showNotification(message, type = 'success') {
    const notification = document.createElement('div');
    notification.className = `custom-notification custom-notification--${type}`;

    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      padding: 12px 24px;
      background: ${type === 'success' ? '#00361B' : '#d32f2f'};
      color: white;
      border-radius: 0;
      z-index: 9999;
      animation: customSlideIn 0.3s ease;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    `;

    notification.textContent = message;
    document.body.appendChild(notification);

    setTimeout(() => {
      notification.style.animation = 'customSlideOut 0.3s ease';
      setTimeout(() => notification.remove(), 300);
    }, 3000);

    if (!document.querySelector('#custom-notification-styles')) {
      const style = document.createElement('style');
      style.id = 'custom-notification-styles';
      style.textContent = `
        @keyframes customSlideIn {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
        @keyframes customSlideOut {
          from { transform: translateX(0); opacity: 1; }
          to { transform: translateX(100%); opacity: 0; }
        }
      `;
      document.head.appendChild(style);
    }
  }

  const CART_ICON_HTML = `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" width="20" height="20" aria-hidden="true" class="cart-icon">
    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6" d="M3.392 6.875h13.216v8.016c0 .567-.224 1.112-.624 1.513-.4.402-.941.627-1.506.627H5.522a2.13 2.13 0 0 1-1.506-.627 2.15 2.15 0 0 1-.624-1.513zM8.818 2.969h2.333c.618 0 1.211.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.313c0-.622.246-1.218.683-1.658a2.33 2.33 0 0 1 1.65-.686"/>
  </svg>
  <span class="add-text-mobile">Carrito</span>
`;

  function initCustomProductCards() {
    document.querySelectorAll('.custom-product-card').forEach((card) => {
      if (card.dataset.initialized === 'true') return;

      const variantButtons = card.querySelectorAll('.variante-btn');
      const priceEl = card.querySelector('.price-item--regular');
      const compareEl = card.querySelector('.price-item--compare');
      const discountBadgeEl = card.querySelector('.price-discount-badge');
      const pricePerGramEl = card.querySelector('.price-per-gram');
      const form = card.querySelector('.custom-product-form');
      const variantInput = form ? form.querySelector('.variant-input') : null;
      const submitButton = form ? form.querySelector('.add-to-cart-button') : null;
      const buyNowButton = form ? form.querySelector('.buy-now-button') : null;
      const addToCartText = submitButton ? submitButton.querySelector('.add-to-cart-text') : null;
      const spinner = submitButton ? submitButton.querySelector('.loading-overlay__spinner') : null;
      const variantWrapper = card.querySelector('.variante-buttons');

      if (variantWrapper) {
        const sortedButtons = Array.from(variantButtons).sort((a, b) => {
          const gramsA = parseFloat(a.dataset.grams);
          const gramsB = parseFloat(b.dataset.grams);
          if (isNaN(gramsA) && isNaN(gramsB)) return 0;
          if (isNaN(gramsA)) return 1;
          if (isNaN(gramsB)) return -1;
          return gramsA - gramsB;
        });

        sortedButtons.forEach((button) => {
          variantWrapper.appendChild(button);
        });
      }

      let isSubmitting = false;
      let isBuyingNow = false;

      variantButtons.forEach((btn) => {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          if (btn.disabled) return;

          variantButtons.forEach((b) => b.classList.remove('active'));
          btn.classList.add('active');

          const variantId = btn.dataset.variantId;
          const priceCents = parseInt(btn.dataset.priceCents || btn.dataset.price, 10);
          const comparePriceCents = parseInt(btn.dataset.comparePriceCents, 10);
          const grams = parseFloat(btn.dataset.grams);
          const isAvailable = !btn.disabled;
          const showCompare = !isNaN(comparePriceCents) && comparePriceCents > priceCents;

          if (priceEl && !isNaN(priceCents)) {
            priceEl.textContent = formatMoneyFromCents(getPriceWithVatCents(priceCents));
          }

          if (compareEl) {
            if (showCompare) {
              compareEl.textContent = formatMoneyFromCents(getPriceWithVatCents(comparePriceCents));
              compareEl.style.display = '';
            } else {
              compareEl.style.display = 'none';
            }
          }

          if (discountBadgeEl) {
            if (showCompare) {
              const discountPercent = Math.round(((comparePriceCents - priceCents) / comparePriceCents) * 100);
              discountBadgeEl.textContent = '-' + discountPercent + '%';
              discountBadgeEl.style.display = '';
            } else {
              discountBadgeEl.style.display = 'none';
            }
          }

          if (pricePerGramEl) {
            if (!isNaN(grams) && grams > 0 && !isNaN(priceCents)) {
              const pricePerGramCents = getPriceWithVatCents(priceCents) / grams;
              pricePerGramEl.textContent = formatMoneyFromCents(pricePerGramCents) + '/g';
            } else {
              pricePerGramEl.textContent = '';
            }
          }

          if (variantInput) {
            variantInput.value = variantId;
          }

          card.dataset.variantId = variantId;

          if (submitButton && addToCartText) {
            submitButton.disabled = !isAvailable;
            addToCartText.innerHTML = CART_ICON_HTML;
          }

          if (buyNowButton) {
            buyNowButton.disabled = !isAvailable;
          }
        });
      });

      if (form) {
        form.addEventListener('submit', async function (e) {
          e.preventDefault();
          e.stopPropagation();

          if (isSubmitting) return;
          if (submitButton && submitButton.disabled) return;

          isSubmitting = true;

          if (submitButton) submitButton.disabled = true;
          if (buyNowButton) buyNowButton.disabled = true;
          if (addToCartText) addToCartText.style.display = 'none';
          if (spinner) spinner.classList.remove('hidden');

          try {
            const formData = new FormData(form);

            const addResponse = await fetch('/cart/add.js', {
              method: 'POST',
              body: formData,
              headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
            });

            if (!addResponse.ok) {
              const errorData = await addResponse.json().catch(() => null);
              throw new Error(errorData?.description || 'Error al añadir al carrito');
            }

            const addedItem = await addResponse.json();

            const cartResponse = await fetch('/cart.js', {
              method: 'GET',
              headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
            });

            const fullCart = await cartResponse.json();

            document.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  data: {
                    itemCount: fullCart.item_count,
                    source: 'custom-product-card',
                  },
                },
              })
            );

            document.dispatchEvent(new CustomEvent('cart:refresh'));

            const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('cart-drawer-component');

            if (cartDrawer) {
              if (typeof cartDrawer.open === 'function') {
                cartDrawer.open();
              } else {
                cartDrawer.setAttribute('open', '');
              }
            }

            card.dispatchEvent(
              new CustomEvent('cart:add', {
                detail: {
                  variantId: variantInput ? variantInput.value : null,
                  quantity: 1,
                  item: addedItem,
                  cart: fullCart,
                },
                bubbles: true,
              })
            );

            showNotification('Producto añadido al carrito', 'success');
          } catch (error) {
            console.error('Error al añadir al carrito:', error);
            showNotification(error.message || 'Error al añadir al carrito', 'error');
          } finally {
            isSubmitting = false;

            const activeBtn = card.querySelector('.variante-btn.active');
            const hasVariantButtons = card.querySelectorAll('.variante-btn').length > 0;
            const isAvailable = hasVariantButtons ? !!(activeBtn && !activeBtn.disabled) : true;

            if (submitButton) submitButton.disabled = !isAvailable;
            if (buyNowButton) buyNowButton.disabled = !isAvailable;

            if (addToCartText) {
              addToCartText.style.display = 'inline';
              addToCartText.innerHTML = CART_ICON_HTML;
            }

            if (spinner) spinner.classList.add('hidden');
          }
        });
      }

      if (buyNowButton) {
        buyNowButton.addEventListener('click', async function (e) {
          e.preventDefault();
          e.stopPropagation();

          if (isBuyingNow) return;
          if (buyNowButton.disabled) return;
          if (!variantInput || !variantInput.value) return;

          isBuyingNow = true;

          try {
            buyNowButton.disabled = true;
            if (submitButton) submitButton.disabled = true;

            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify({
                id: variantInput.value,
                quantity: 1,
              }),
            });

            if (!response.ok) {
              const errorData = await response.json().catch(() => null);
              throw new Error(errorData?.description || 'Error al añadir al carrito');
            }

            window.location.href = '/checkout';
          } catch (error) {
            console.error('Error en Comprar ahora:', error);
            showNotification(error.message || 'Error al procesar la compra', 'error');

            isBuyingNow = false;

            const activeBtn = card.querySelector('.variante-btn.active');
            const hasVariantButtons = card.querySelectorAll('.variante-btn').length > 0;
            const isAvailable = hasVariantButtons ? !!(activeBtn && !activeBtn.disabled) : true;

            if (buyNowButton) buyNowButton.disabled = !isAvailable;
            if (submitButton) submitButton.disabled = !isAvailable;
          }
        });
      }

      card.dataset.initialized = 'true';
    });
  }

  document.addEventListener('DOMContentLoaded', initCustomProductCards);
  document.addEventListener('shopify:section:load', initCustomProductCards);
  document.addEventListener('shopify:section:select', initCustomProductCards);

  if (!window.customProductCardObserver) {
    window.customProductCardObserver = new MutationObserver(() => {
      initCustomProductCards();
    });

    window.customProductCardObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  initCustomProductCards();
  } catch(e) { console.error(e); }
})();

})();
